import { render } from "./governance.html?vue&type=template&id=455971e9&external"
import script from "./governance.js?vue&type=script&lang=js&external"
export * from "./governance.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__